var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMorvernGroupLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 118.631,
    height: 32.566,
    viewBox: "0 0 118.631 32.566",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4697",
    "data-name": "Rectangle 4697",
    width: 118.631,
    height: 32.566,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28946",
    "data-name": "Group 28946",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_28945",
    "data-name": "Group 28945",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_140950",
    "data-name": "Path 140950",
    d: "M2.75.345A.389.389,0,0,1,3.165,0h.369a.419.419,0,0,1,.392.23L9,11.112h.07L14.139.23A.4.4,0,0,1,14.531,0H14.9a.389.389,0,0,1,.415.345l2.72,15.491a.4.4,0,0,1-.415.53h-2.1a.5.5,0,0,1-.438-.345l-1.36-8.737h-.069L9.62,16.344a.39.39,0,0,1-.392.253H8.813a.412.412,0,0,1-.392-.253L4.341,7.285H4.272L2.935,16.022a.446.446,0,0,1-.415.345H.445a.423.423,0,0,1-.438-.53Z",
    transform: "translate(0 0)",
    fill: "#7e878b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140951",
    "data-name": "Path 140951",
    d: "M36.248,5.237a4.265,4.265,0,0,0-3.8,2.46,3.327,3.327,0,0,1,2.8-1.566,3.341,3.341,0,1,1,0,6.682,3.332,3.332,0,0,1-2.887-1.683,4.226,4.226,0,0,0,8.1-1.224c.011-.137.02-.275.02-.415a4.3,4.3,0,0,0-4.235-4.254",
    transform: "translate(-7.249 -1.173)",
    fill: "#ebb500"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140952",
    "data-name": "Path 140952",
    d: "M34.98,0a8.3,8.3,0,1,1,0,16.6A8.225,8.225,0,0,1,26.7,8.321,8.264,8.264,0,0,1,34.98,0m0,13.6A5.3,5.3,0,1,0,29.7,8.321,5.314,5.314,0,0,0,34.98,13.6",
    transform: "translate(-5.981 0)",
    fill: "#7e878b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140953",
    "data-name": "Path 140953",
    d: "M71.19.9a.407.407,0,0,1,.392-.6h2.351a.424.424,0,0,1,.392.253l4.426,9.913h.161L83.339.55A.423.423,0,0,1,83.73.3h2.351a.407.407,0,0,1,.392.6L79.327,16.411a.414.414,0,0,1-.392.254H78.7a.415.415,0,0,1-.392-.254Z",
    transform: "translate(-15.933 -0.066)",
    fill: "#7e878b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140954",
    "data-name": "Path 140954",
    d: "M95.088.735A.438.438,0,0,1,95.526.3h9.382a.438.438,0,0,1,.438.438V2.626a.437.437,0,0,1-.438.437H98.085V6.844h5.694a.452.452,0,0,1,.438.438V9.2a.437.437,0,0,1-.438.437H98.085v4.035h6.824a.437.437,0,0,1,.438.437V16a.437.437,0,0,1-.438.437H95.526A.438.438,0,0,1,95.088,16Z",
    transform: "translate(-21.296 -0.066)",
    fill: "#7e878b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140955",
    "data-name": "Path 140955",
    d: "M135.312.415A.434.434,0,0,1,135.75,0h.576l9.59,10.189h.022V.669a.438.438,0,0,1,.438-.438H148.5a.454.454,0,0,1,.438.438V16.184a.433.433,0,0,1-.438.414h-.553L138.309,6.017h-.023V15.93a.438.438,0,0,1-.438.438h-2.1a.453.453,0,0,1-.438-.438Z",
    transform: "translate(-30.305 0)",
    fill: "#7e878b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140956",
    "data-name": "Path 140956",
    d: "M122.686,9.91A5.088,5.088,0,0,0,126.1,5.253,4.993,4.993,0,0,0,121.073.3h-6.593a.438.438,0,0,0-.438.438V16a.438.438,0,0,0,.438.438H116.6a.454.454,0,0,0,.438-.438v-3.62l.023-2.258V3.063h3.758A2.294,2.294,0,0,1,123.1,5.3a2.349,2.349,0,0,1-2.282,2.351h-2.46l4.3,8.575a.4.4,0,0,0,.369.208h2.42a.436.436,0,0,0,.392-.669Z",
    transform: "translate(-25.541 -0.066)",
    fill: "#7e878b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140957",
    "data-name": "Path 140957",
    d: "M61.313,9.91a5.088,5.088,0,0,0,3.411-4.657A4.993,4.993,0,0,0,59.7.3H53.106a.438.438,0,0,0-.438.438V16a.438.438,0,0,0,.438.438h2.121A.454.454,0,0,0,55.665,16v-3.62l.023-2.258V3.063h3.758A2.294,2.294,0,0,1,61.728,5.3a2.349,2.349,0,0,1-2.282,2.351h-2.46l4.3,8.575a.4.4,0,0,0,.369.208h2.42a.436.436,0,0,0,.392-.669Z",
    transform: "translate(-11.796 -0.066)",
    fill: "#7e878b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140958",
    "data-name": "Path 140958",
    d: "M52.193,33.386a3.5,3.5,0,0,1,2.256.86.179.179,0,0,1,.009.259l-.573.6a.157.157,0,0,1-.241,0,2.11,2.11,0,1,0-1.388,3.727,2.9,2.9,0,0,0,1.1-.23v-.786h-.74a.168.168,0,0,1-.175-.167v-.73a.17.17,0,0,1,.175-.176h1.776a.174.174,0,0,1,.166.176v2.367a.177.177,0,0,1-.074.148,4.673,4.673,0,0,1-2.293.6,3.324,3.324,0,0,1,0-6.648",
    transform: "translate(-10.946 -7.477)",
    fill: "#7e878b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140959",
    "data-name": "Path 140959",
    d: "M75.768,33.386a3.329,3.329,0,1,1-3.32,3.338,3.323,3.323,0,0,1,3.32-3.338m0,5.456a2.127,2.127,0,1,0-2.118-2.118,2.131,2.131,0,0,0,2.118,2.118",
    transform: "translate(-16.226 -7.477)",
    fill: "#7e878b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140960",
    "data-name": "Path 140960",
    d: "M86.035,33.68a.182.182,0,0,1,.175-.175h.879a.175.175,0,0,1,.175.175v3.782a1.346,1.346,0,1,0,2.691.009V33.68a.175.175,0,0,1,.176-.175h.878a.182.182,0,0,1,.175.175v3.847a2.575,2.575,0,0,1-5.151,0Z",
    transform: "translate(-19.269 -7.504)",
    fill: "#7e878b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140961",
    "data-name": "Path 140961",
    d: "M98.3,33.681a.176.176,0,0,1,.175-.176h2.173a2.062,2.062,0,1,1,.009,4.125H99.5V39.8a.182.182,0,0,1-.175.175h-.851A.175.175,0,0,1,98.3,39.8Zm2.275,2.82a.953.953,0,0,0,.952-.962.922.922,0,0,0-.952-.9H99.5V36.5Z",
    transform: "translate(-22.015 -7.504)",
    fill: "#7e878b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_140962",
    "data-name": "Path 140962",
    d: "M65,37.361a2.04,2.04,0,0,0,1.368-1.868A2,2,0,0,0,64.351,33.5H61.706a.176.176,0,0,0-.175.176V39.8a.175.175,0,0,0,.175.176h.851a.182.182,0,0,0,.176-.176V38.35l.009-.906V34.615h1.507a.92.92,0,0,1,.915.9.942.942,0,0,1-.915.943h-.986l1.726,3.44a.159.159,0,0,0,.148.083h.971a.175.175,0,0,0,.157-.269Z",
    transform: "translate(-13.781 -7.504)",
    fill: "#7e878b"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMorvernGroupLogo);
export default __webpack_public_path__ + "static/media/morvern-group-logo.0030901c91c2cdc6bbda4fc4dc98ec94.svg";
export { ForwardRef as ReactComponent };